module.exports = __webpack_public_path__ + "img/img_xiaoxi_empty.6931b139.png";